'use client';

import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';

export const TaxModalFooter = ({ logoutUrl, isNotValid }) => {
  const t = useTranslations();
  return (
    <section className="d-flex gap-2">
      <CatButton variant="primary" type="submit" disabled={isNotValid}>
        {t('SUBMIT')}
      </CatButton>
      <CatButton variant="ghost" href={logoutUrl}>
        {t('ADS_CONTINUE_AS_GUEST_BUTTON')}
      </CatButton>
    </section>
  );
};
